import React from "react";
import { HighlightOff, KeyboardBackspace } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { actions } from "../../../_redux/homepageRedux";
import queryStringParse from "../../../../../../functions/queryParam";
const MobileNotificationAndHeader = (props) => {
  const [townships, setTownships] = React.useState({});

  const history = useHistory();
  const dispatch = useDispatch();

  const state = useSelector((state) => state.homepage);
  const townshipsState = useSelector((state) => state.townships);

  // const persianDateHandler = () => {

  //   console.log("ASd",props);
  //   const urlDate = history.location.pathname.split("/")[4];
    
  //   let dateOptions = {
  //     weekday: "long",
  //     year: "numeric",
  //     month: "long",
  //     day: "numeric",
  //   };
  //   const persianDate = new Date(urlDate.replace(/-/g, "/")).toLocaleDateString(
  //     "fa-Ir",
  //     dateOptions
  //   );

  //   const day = persianDate.split(",")[1];
  //   const monthAnddate = persianDate.split(",")[0].split(" ");

  //   const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

  //   return mixed;
  // };

  //change url to ? query param 
  const persianDateHandler = () => {
    let params=[];

    
  //   if (history.location.search ) {
  //     var search = history.location.search;
  //      params = queryStringParse(search);
   
  //  }
  //  const urlDate = params.date;
  const urlDate = props.date;
    let dateOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const persianDate = new Date(urlDate.replace(/-/g, "/")).toLocaleDateString(
      "fa-Ir",
      dateOptions
    );

    const day = persianDate.split(",")[1];
    const monthAnddate = persianDate.split(",")[0].split(" ");

    const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

    return mixed;
  };
  return (
    <>
      <div
        style={{ backgroundColor: "#6dd06d", height: "5rem" }}
        className="w-100  d-flex text-white justify-content-center shadow-sm align-items-center p-5"
      >
        <div
          className="col-1"
          onClick={() => {
            history.push("/");
          }}
        >
          <i
            className="fa fa-arrow-right text-white"
            style={{ fontSize: "2rem" }}
          ></i>
        </div>
        <div className="col-9 px-3" style={{ marginRight: "1rem" }}>
          <h4 className="text-white">
            <b>
              بلیط اتوبوس{" "}
              {townshipsState?.srcAndDestTitle?.source.title
                ? townshipsState?.srcAndDestTitle?.source.title
                : null}{" "}
              به{" "}
              {townshipsState?.srcAndDestTitle?.dest.title
                ? townshipsState?.srcAndDestTitle?.dest.title
                : null}{" "}
            </b>
          </h4>
          <h6 className="text-white">
            {persianDateHandler()}
            {/* {console.log('persianDate',persianDateHandler())} */}
          </h6>
        </div>
        <div
          className="col-2 p-1"
          onClick={() => {
            // history.push("/");
            dispatch(actions.setMobileDialog(true));
          }}
        >
          <i
            className="fa fa-search text-white"
            style={{ fontSize: "2rem" }}
          ></i>
        </div>
        {/* <div className="col-6 p-5">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "10px" }}
          >
            <h3 className="text-white">
              <b>
                {townshipsState.srcAndDestTitle?.source.title
                  ? townshipsState.srcAndDestTitle?.source.title
                  : null}
              </b>
            </h3>
            <KeyboardBackspace style={{ fontSize: "3rem" }} />
            <h3 className="text-white">
              <b>
                {" "}
                {townshipsState.srcAndDestTitle?.dest.title
                  ? townshipsState.srcAndDestTitle?.dest.title
                  : null}
              </b>
            </h3>
          </div>
          <h5 className="text-center text-white" style={{ fontSize: "18px" }}>
            <b>
              {persianDateHandler()[3]}
              {persianDateHandler()[2]}
              {persianDateHandler()[1]}
            </b>
          </h5>
        </div>
        <div
          style={{ height: "4.5rem", padding: "5px" }}
          className="col-6 d-flex align-items-center justify-content-center"
        >
          <Button
            className="w-75 h-100"
            style={{
              border: "1px solid gray",
              backgroundColor: "white",
              borderRadius: "13px",
            }}
            onClick={() => {
              history.push("/");
            }}
          >
            <h6
              className="mx-auto my-auto"
              style={{
                color: "gray",
              }}
            >
              <b>ویرایش</b>
            </h6>
          </Button>
        </div> */}
      </div>
    </>
  );
};

export default MobileNotificationAndHeader;
